<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		WSinit
	} from "@/utils/websocketMessageHandler.js";
	import {
		Getitem
	} from "@/utils/item";
	import {
		PROtype,
		templogin,
		initUserCheck
	} from "@/utils/request.js";
	import store from "@/store";

	export default {
		data() {
			return {
				userId: "",
				clientId: "cus",
			};
		},

		async created() {
			// 初始化用户信息
			let s = await Getitem("userid");
			let sv = await Getitem("user");

			if (!s || s === "") {
				let res = await templogin();
				await PROtype(res.token);
			} else {
				await PROtype(sv);
			}

			let newlist = await Getitem("setmenu");
			this.$store.commit("SETprjectmenu", newlist);
			this.userId = await Getitem("userid");

			// 初始化 WebSocket
			await this.initWebSocket();

			// 初始化用户检查
			initUserCheck();

			// 注册可见性变化监听（H5）
			if (typeof document !== "undefined") {
				document.addEventListener("visibilitychange", this.handleVisibilityChange);
			}
		},

		methods: {
			// 初始化 WebSocket
			initWebSocket() {
				if (this.userId) {
					// console.log("[App] 初始化 WebSocket");
					WSinit(this.clientId, this.userId);
				} else {
					// console.warn("用户ID不存在，无法初始化WebSocket");
				}
			},

			// 页面前后台切换时的处理（H5）
			handleVisibilityChange() {
				const ws = store.state.mews;
				if (document.visibilityState === "visible") {
					// console.log("[App] 页面重新激活，检查 WebSocket 状态");
					setTimeout(() => {
						if (!ws || !ws.getIsOnline()) {
							// console.log("[WebSocket] 页面激活检测到离线，尝试重连");
							ws && ws.reconnect();
						}
					}, 2000);
				} else {
					// console.log("[App] 页面进入后台");
				}
			},
		},

		// uniapp 小程序/APP 生命周期钩子
		onShow() {
			console.log("[App] 应用进入前台");
			setTimeout(() => {
				const ws = store.state.mews;
				if (!ws || !ws.getIsOnline()) {
					// console.log("[WebSocket] 前台检测到断开，尝试重连");
					ws && ws.reconnect();
				}
			}, 2000);
		},

		onHide() {
			// console.log("[App] 应用进入后台");
		},

		beforeUnmount() {
			// 组件销毁时移除事件监听（H5）
			if (typeof document !== "undefined") {
				document.removeEventListener("visibilitychange", this.handleVisibilityChange);
			}
		},
	};
</script>

<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	html,
	body {
		margin: 0;
		font-size: 16px;
	}
</style>